import { ActivityDefinition } from 'modules/core/lib/activities/types'
import { ManifestsType, manifests } from 'modules/core/lib/manifests/manager'

type ActivityPaths<T, Prefix extends string = ''> = {
  [K in keyof T]: T[K] extends ActivityDefinition<any>
    ? `${Prefix}${K & string}`
    : T[K] extends { activities: infer A }
      ? ActivityPaths<A, `${Prefix}${K & string}.`>
      : never
}[keyof T]

export type ExtractActivity<T, Path extends string> = Path extends `${infer Key}.${infer Rest}`
  ? Key extends keyof T
    ? T[Key] extends { activities: infer A }
      ? ExtractActivity<A, Rest>
      : never
    : never
  : Path extends keyof T
    ? T[Path]
    : never

export function getActivity<Path extends ActivityPaths<ManifestsType>>(
  path: Path
): ExtractActivity<ManifestsType, Path> | null {
  const [section, activity] = path.split('.') as [keyof ManifestsType, string]
  const activityObject = (manifests[section] as any)?.activities[activity]

  if (activityObject) {
    return activityObject as ExtractActivity<ManifestsType, Path>
  }

  return null
}

export type ActivityCatalog = ActivityPaths<ManifestsType>
